

export enum PatchManagerRequestType {
	None,
	GetCampuses,
	GetBuildings,
	LookupJackToSwitchPort,
	LookupSwitchToJack,
	LookupRoomToJacks,
	GetRooms,
}


export interface Campus {
	entityID: string;
	name: string;
}


export interface Building {
	entityID: string;
	name: string;
	label: string;
}

export interface Room {
	entityID: string;
	name: string;
	label: string;
}

export interface JackToSwitchConnection {
	jack_label: string;
	jack_room: string;
	jack_building: string;
	campus: string;
	switch_label: string;
	switch_model_label: string;
	switch_port_label: string;
	switch_name: string;
	switch_module_name: string;
	switch_module_port_name: string;
	switch_ip: string;
	ifAlias: string;
	ifName: string;
	ifIndex: string;
	ifVLANs: string;
	connectedDevices: string;
}


export interface SwitchToJackConnection {
	switch_label: string;
	switch_module_label: string;
	switch_port_label: string;
	jack_label: string;
	jack_room: string;
	jack_building: string;
	switch_name: string;
	switch_module_name: string;
	switch_module_port_name: string;
	switch_if_index: string;
	stale_port_days: string;
}


export interface ExtraIfInfo {
	ifIndex: number;
	hasBridgePort: boolean;
}


export interface PatchManagerResultDto {
	succeeded: boolean;
	message: string;
	requestType: PatchManagerRequestType;
	campuses?: Campus[];
	buildings?: Building[];
	rooms?: Room[];
	jackToSwitchConnection: JackToSwitchConnection;
	ipAddress?: string;
	vlan?: string;
	connected?: string;
	switchToJackConnections: SwitchToJackConnection[];
	extraIfInfo: ExtraIfInfo[];
	roomJacksConnections: JackToSwitchConnection[];
}
